export default "__VITE_ASSET__CQYuvhnH__"